import React from "react";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/gs-admin/members/")({
  component: () => <Navigate to="/gs-admin/members/enroll" />,
});
